import React from 'react';
import { ArrowRight } from 'lucide-react';
import { heroData } from '../data/mock';

const HeroSection = () => {
  const scrollToContact = () => {
    document.getElementById('booking')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToPortfolio = () => {
    document.getElementById('portfolio')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Fullscreen Background Image */}
      <div className="absolute inset-0">
        <img
          src="/hero-bg.jpg"
          alt="Northlight Visuals Hero"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Subtle shadow/gradient on the left side for text readability */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/40 to-transparent" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 lg:px-8 py-16 w-full">
        <div className="max-w-2xl space-y-6 lg:space-y-7">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-3 py-1.5 lg:px-4 lg:py-2 bg-black/30 backdrop-blur-sm border border-white/10 rounded-full animate-fade-in-up">
            <div className="w-1.5 h-1.5 rounded-full bg-[#ff84e4]" />
            <span className="text-xs lg:text-sm text-gray-200 tracking-wide">{heroData.badge}</span>
          </div>

          {/* Headline */}
          <h1 className="text-[1.7rem] sm:text-4xl md:text-5xl lg:text-[3.4rem] font-bold leading-[1.1] animate-fade-in-up stagger-1 font-display tracking-tight text-white drop-shadow-lg">
            High-End-Shooting-Qualität
            <br />
            ohne{' '}
            <span className="text-gradient">High-End-Shooting-Aufwand</span>
          </h1>

          {/* Subheadline */}
          <p className="text-sm lg:text-lg text-gray-200 max-w-xl leading-relaxed animate-fade-in-up stagger-2 drop-shadow-md">
            {heroData.subheadline}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-3 lg:gap-4 animate-fade-in-up stagger-3">
            <button
              data-testid="hero-cta-primary"
              onClick={scrollToContact}
              className="group px-6 py-3.5 lg:px-8 lg:py-4 bg-[#ff84e4] text-black font-semibold rounded-full transition-colors duration-200 hover:bg-[#ffd1e7] flex items-center gap-2 text-sm lg:text-base"
            >
              {heroData.ctaPrimary}
              <ArrowRight size={18} className="transition-transform duration-200 group-hover:translate-x-1" />
            </button>
            <button
              data-testid="hero-cta-secondary"
              onClick={scrollToPortfolio}
              className="px-6 py-3.5 lg:px-8 lg:py-4 bg-black/30 backdrop-blur-sm border border-white/20 text-white font-semibold rounded-full transition-colors duration-200 hover:bg-black/50 hover:border-white/30 text-sm lg:text-base"
            >
              {heroData.ctaSecondary}
            </button>
          </div>

          {/* Trust line */}
          <div className="pt-4 lg:pt-5 border-t border-white/10 animate-fade-in-up stagger-4">
            <div className="flex flex-wrap gap-x-6 lg:gap-x-8 gap-y-1 text-xs lg:text-sm text-gray-300/80">
              <span>Fashion & Accessoires</span>
              <span>Höchste Qualität</span>
              <span>High-End Retouching</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
